import CreateWorkflowMetadataStep from 'src/components/createWorkflow/createWorkflowMetadataStep/CreateWorkflowMetadataStep';
import ConfigureAttributeStep from 'src/components/createWorklow/configureAttributeStep/ConfigureAttributeStep';
import UpdateWFDefinitionReviewStep from 'src/components/createWorklow/updateWFDefinitionReviewStep/updateWFDefinitionReviewStep';
import UpdateWFDefinitionStep from 'src/components/createWorklow/updateWFDefinitionStep/updateWFDefinitionStep';

export const STEP_METADATA = 0;
export const STEP_DEFINITION = 1;
export const STEP_AUTO_POPULATION = 2;
export const STEP_REVIEW = 3;

export const getWorkflowSteps = (isEditMode) => {
	return [
		{
			title: `${isEditMode ? 'Edit ' : 'Create '}Workflow`,
			StepContent: CreateWorkflowMetadataStep,
		},
		{
			title: 'Design Workflow',
			StepContent: UpdateWFDefinitionStep,
		},
		{
			title: 'Attribute Configuration',
			StepContent: ConfigureAttributeStep,
		},
		{
			title: 'Review Workflow',
			StepContent: UpdateWFDefinitionReviewStep,
		},
	];
};
